import { FormEvent } from 'react';
import { LoginFormData, LoginValidationErrors } from '../hooks/useLoginValidation';
import { Input, PasswordInput } from '../../../components/shared';
import { Button } from '@/components/ui/button';

interface LoginFormProps {
  formData: LoginFormData;
  onChange: (field: keyof LoginFormData, value: string) => void;
  onSubmit: (e: FormEvent) => void;
  errors: LoginValidationErrors;
  loading: boolean;
}

export function LoginForm({ formData, onChange, onSubmit, errors, loading }: LoginFormProps) {
  return (
    <form onSubmit={onSubmit} className="space-y-6" data-testid="login-form">
      <Input
        id="email"
        label="E-mail"
        type="email"
        value={formData.email}
        onChange={(e) => onChange('email', e.target.value)}
        error={errors.email}
        loading={loading}
        required
        variant="primary"
      />

      <PasswordInput
        id="password"
        label="Senha"
        value={formData.password}
        onChange={(e) => onChange('password', e.target.value)}
        error={errors.password}
        loading={loading}
        required
        variant="primary"
      />

      <Button type="submit" disabled={loading} className="w-full">
        {loading ? 'ENTRANDO...' : 'ENTRAR'}
      </Button>
    </form>
  );
}